export enum SidebarSize {
  SMALL,
  MEDIUM,
  FULL,
}
